import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setFieldValue from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SetFieldValue";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ContactFormContext } from "@insite/content-library/Widgets/ContactUs/ContactForm";
import Select, { SelectPresentationProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    label = "label",
    hintText = "hintText",
    topics = "topics",
    isRequired = "isRequired",
}

interface TopicModel {
    fields: {
        topic: string;
    };
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.label]: string;
        [fields.hintText]: string;
        [fields.topics]: TopicModel[];
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    topic: state.components.contactUsForm.fieldValues["topic"],
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface QueryTypetextFieldStyles {
    topicsSelect?: TextFieldPresentationProps;
}

export const QueryTypetextFieldStyles: QueryTypetextFieldStyles = {};

export const styles = QueryTypetextFieldStyles;

const QueryTypetextField: React.FC<Props> = ({ fields, topic, setFieldValue }) => {
    const { label, hintText, topics, isRequired } = fields;
    const contactFormContext = React.useContext(ContactFormContext);
    const [topicErrorMessage, setTopicErrorMessage] = React.useState("");

    React.useEffect(() => {
        contactFormContext.validators.topic = validateTopic;
        if (typeof topic !== "undefined") {
            validateTopic();
        }
    }, [topic]);

    React.useEffect(() => {
        contactFormContext.validators.topic = validateTopic;
    }, [isRequired]);

    const validateTopic = () => {
        const errorMessage = isRequired && !topic ? (siteMessage("Field_Required", label) as string) : "";
        setTopicErrorMessage(errorMessage);
        return !errorMessage;
    };

    const topicChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "topic", value: event.target.value });
    };

    return (
        <TextField
            {...styles.topicsSelect}
            label={label}
            required={isRequired}
            placeholder={hintText}
            value={topic || ""}
            error={topicErrorMessage}
            onChange={topicChangeHandler}
        />
    );
};
const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(QueryTypetextField),
    definition: {
        group: "Contact Us",
        icon: "FormField",
        fieldDefinitions: [
            {
                name: fields.label,
                displayName: "Label",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Topics",
                isRequired: true,
            },
            {
                name: fields.hintText,
                displayName: "Hint Text",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Enter Purpose of Reaching Us",
                isRequired: true,
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
